export const rangoFechas = {
  desde: "Von",
  hasta: "Bis",
  etiqueta: "Daten",
  quitar: "Daten entfernen",
  titulo: "Daten wählen",
  elegirInicio: "Ersten Tag antippen",
  elegirFin: "Jetzt den letzten Tag antippen",
  dias: "Tag | Tage",
  anterior: "Vorheriger Monat",
  siguiente: "Nächster Monat",
  cancelar: "Abbrechen",
  aplicar: "Übernehmen",
};
